module.exports = __webpack_public_path__ + "img/48_16.18817178.png";